import React, { useState } from "react";
import { DashboardContainer } from "./styles";
import DashboardTabMenu from "./components/DashboardTabMenu";
import Graficos from "./components/Graficos";
import Indicadores from "./components/Indicadores";

function DashboardView(): JSX.Element {
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <DashboardContainer>
      <DashboardTabMenu active={activeTab} setActive={setActiveTab} />
      {activeTab === "dashboard" && <Graficos />}
      {activeTab === "indicadores" && <Indicadores />}
    </DashboardContainer>
  );
}

export default DashboardView;
